import { notification } from "antd";

export default class Helpers {
  /**
   * Alert an success message
   * @param {string} message the success message
   * @returns {void}
   * @static
   * @memberof Helpers
   */
  static alertSuccessMessage = (message = "") => {
    notification["success"]({
      message: "Thông báo",
      className: "notifi-success",
      description: message,
    });
  };

  /**
   * Alert an error message
   * @param {string} error the error message
   * @returns {void}
   * @static
   * @memberof Helpers
   */
  static alertError = (error = "") => {
    notification["error"]({
      type: "error",
      className: "notifi-error",
      message: "Thông báo",
      description: error,
    });
  };

  /**
   *
   *
   * @static
   * @param {string} [message=""]
   * @memberof Helpers
   */
  static alertWarning = (message = "") => {
    notification["warning"]({
      type: "warning",
      className: "notifi-warning",
      message: "Thông báo",
      description: message,
    });
  };
}
